// 巡检记录
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { theme, Card, Tag, Table, message, Pagination, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { getGodMapIndexInfo } from '@/server/godMap.js'
import GodMapTable from './godMapTable'

function GodMapIndex () {
  const [loading, setLoading] = useState(false);
  const location = useLocation();//接受传值数据
  const token = localStorage.getItem('dock_token');
  const {
    token: { colorText, colorTextQuaternary },
  } = theme.useToken(); //获取主题颜色


  useEffect(() => {
    // eslint-disable-next-line 
  }, [])


  return (
    <div className='mar24'>
      <Card style={{ border: 0 }} styles={{ body: { padding: '24px' } }}>
        <GodMapTable></GodMapTable>
      </Card>
    </div>
  )
}
export default GodMapIndex